import { message } from "antd";

export const ErrorMessageFormAPI = message => {
    // console.log(message);

    let newMessage = [];
    newMessage["AUTH_USER_OR_PASS_INVALID"] = "รหัสผ่านไม่ถูกต้อง";
    newMessage["Invalid account."] = "รหัสบุคลากรไม่ถูกต้อง";
    newMessage["Email is invalid format"] = "รูปแบบอีเมลไม่ถูกต้อง";
    newMessage["Verify Code doesn't exists or invalid."] = "รหัสยืนยันไม่ถูกต้อง";
    newMessage["Password required at leaset 6 characters long."] = "รหัสผ่านต้องมีความยาวมากกว่า 6 ตัวอักษรขึ้นไป";
    newMessage["Password required at least one lower case letter, upper case letter and one number."] = "รหัสผ่านต้องมีอักษรตัวพิมพ์เล็กตัวพิมพ์ใหญ่และตัวเลขอย่างน้อยหนึ่งตัว";
    newMessage["Password doesn't match."] = "รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน";
    newMessage["Password not match"] = "รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน";
    newMessage['Identity Card is incorrect'] = "เลขบัตรประจำตัวประชาชนไม่ถูกต้อง";
    newMessage['AUTH_USER_OR_ORG_INVALID'] = "สำนักไม่ถูกต้อง";
    newMessage["PROFILE_INVALID"] = "กรุณากรอกข้อมูลให้ถูกต้อง";
    newMessage['VERIFY_INVALID'] = "ข้อมูลยืนยันไม่ถูกต้อง";
    newMessage["VERIFY_CODE_INVALID"] = "รหัสยืนยันไม่ถูกต้อง";
    newMessage["PASSWORD_AT_LEAST_REQUIRED"] = "รหัสผ่านต้องมีความยาวมากกว่า 8 ตัวขึ้นไป";
    newMessage["PASSWORD_INVALID_FORMAT"] = "รหัสผ่านต้องมีอักษรตัวพิมพ์เล็กตัวพิมพ์ใหญ่และอักษรพิเศษและตัวเลขอย่างน้อยหนึ่งตัว";
    newMessage["VERIFY_CODE_ALREADY_USED"] = "รหัสยืนยันถูกใช้งานแล้ว";
    newMessage["PASSWORD_DOESNT_MATCH"] = "รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน";
    
    if (newMessage[message] != null) {
        return newMessage[message]
    } else {
        return message
    }
}


export const ErrorMessageFormAPIApollo = (graphQLErrors) =>{
    // console.log(graphQLErrors)
    let newMessage = [];
    newMessage["PAYROLL_SLIP_NOT_EXISTS"] = graphQLErrors.message;
    newMessage["TOKEN_INVALID"] = "ไม่พบชื่อบัญชีหรือบัญชีไม่ถูกต้อง";
    // newMessage["INTERNAL_SERVER_ERROR"] = "มีบ้างอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง";
    newMessage["INTERNAL_SERVER_ERROR"] = "";
    newMessage["AUTH_USER_OR_PASS_INVALID"] = graphQLErrors.message;
    newMessage["USER_OR_ORG_WRONG"] = graphQLErrors.message;
    newMessage["PASSWORD_OLD_INCORRECT"] = 'รหัสผ่านเดิมไม่ถูกต้อง';
    newMessage["PASSWORD_AT_LEAST_REQUIRED"] = 'รหัสผ่านต้องมีความยาวมากกว่า 8 ตัวขึ้นไป';
    newMessage["PASSWORD_INVALID_FORMAT"] = 'รหัสผ่านต้องมีอักษรตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ ตัวเลข และอักขระพิเศษ รวมกันแล้วมากกว่า 8 ตัวขึ้นไป';
    newMessage["SMS_SEND_ERROR"] = graphQLErrors.message;
    newMessage["PHONE_NUMBER_NOT_FOUND"] = graphQLErrors.message;
    newMessage["AUTH_USER_OR_ORG_WITH_CAPTCHA_INVALID"] = graphQLErrors.message;
    newMessage["CAPTCHA_MISMATCH"] = graphQLErrors.message;
    newMessage["ACCOUNT_INVALID"] = "ไม่พบชื่อบัญชีหรือบัญชีไม่ถูกต้อง";
    newMessage["CAPTCHA_EXPIRED"] = "รหัสภาพเก่าหมดอายุ กรุณาระบุใหม่อีกครั้ง";
    newMessage['AUTH_USER_OR_ORG_INVALID'] = graphQLErrors.message;
    // newMessage["PASSWORD_DOESNT_MATCH"] = "รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน";
    newMessage["PASSWORD_DOESNT_MATCH"] = graphQLErrors.message;
    newMessage["VERIFY_CODE_ALREADY_USED"] = graphQLErrors.message;
    newMessage["VERIFY_CODE_INVALID"] = graphQLErrors.message;
    newMessage["OTP_INCORRECT"] = graphQLErrors.message;
    newMessage["PHONE_NUMBER_FORMAT_INVALID"] = graphQLErrors.message;
    newMessage["IDCARD_IS_DUPLICATE"] = graphQLErrors.message;
    newMessage["SLIP_USED"] = graphQLErrors.message;
    newMessage["USER_NOT_FOUND"] = graphQLErrors.message;
    newMessage["DATE_SLIP_DETAIL_INCORRECT"] = graphQLErrors.message;
    newMessage["DATA_INVALID"] = graphQLErrors.message;
    newMessage["DATA_ALREADY_EXIST"] = graphQLErrors.message;
    newMessage["APPROVER_NOT_FOUND"] = graphQLErrors.message;
    newMessage["DATA_NOT_FOUND"] = graphQLErrors.message;

    // console.log('messageErrorsAPI', graphQLErrors)
    if (newMessage[graphQLErrors.extensions.code] != null) {
        return newMessage[graphQLErrors.extensions.code]
    }

}